import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from "@wordpress/element";
import { PipelinesContext } from "../../../../providers/PipelinesContextProvider";
import { WPQTSelect } from "../WPQTSelect";
function PipelineFilterSelect({ selectedOptionValue, selectionChange }) {
    const { state: { pipelines }, } = useContext(PipelinesContext);
    const pipelineOptions = useMemo(() => pipelines.map((pipeline) => ({
        value: pipeline.id,
        label: pipeline.name,
    })), [pipelines]);
    return (_jsx(WPQTSelect, { options: pipelineOptions, selectedOptionValue: selectedOptionValue, onSelectionChange: selectionChange }));
}
export { PipelineFilterSelect };
